import React from "react";
import { ReactComponent as IconTags } from "../../../../assets/images/steps/bookmark.svg";
import { ReactComponent as IconDetails } from "../../../../assets/images/steps/check.svg";
import { ReactComponent as IconImage } from "../../../../assets/images/steps/image.svg";
import { ReactComponent as IconReview } from "../../../../assets/images/steps/schedule.svg";
import "./StepsSidebar.scss";

const steps = [
  { label: "Detalhamento", icon: IconDetails },
  { label: "Tags", icon: IconTags },
  { label: "Geração de imagem", icon: IconImage },
  { label: "Revisão", icon: IconReview },
];

const StepsSidebar = ({ currentStep, onStepChange }) => {
  const currentIndex = steps.findIndex((step) => step.label === currentStep);

  return (
    <aside className="StepsSidebar">
      <p className="steps-title">Etapas</p>
      <p className="steps-description">Conclua todas as etapas para publicar</p>
      <div className="steps-buttons">
        {steps.map(({ label, icon: OriginalIcon }, index) => {
          const isCurrent = index === currentIndex;
          const isCompleted = index < currentIndex;

          return (
            <button
              key={label}
              className={`step-button ${isCurrent || isCompleted ? "active" : ""}`}
            >
              <span className="step-icon">
                {isCompleted ? <IconDetails /> : <OriginalIcon />}
              </span>
              <span className="step-label">{label}</span>
            </button>
          );
        })}
      </div>
    </aside>
  );
};

export default StepsSidebar;
